import {useCallback} from 'react';
import {useAppDispatch} from 'store/customer';
import {
    setIsRoomPlannerEditing,
    setBackupProductValues,
} from 'components/customer/RoomPlanner/store/roomPlannerSlice';
import {useSearchParams} from 'react-router-dom';
import {
    MenuItem,
    useMenuContext,
} from 'components/customer/RoomPlanner/components/Menu/MenuContext';
import {useRoomPlannerContext} from 'components/customer/RoomPlanner/components/RoomPlannerContext';
import {useOpenPlaceholderEditor} from 'components/customer/RoomPlanner/components/FloatingMenu/Actions/PlaceholderEdit';

export const useEditProduct = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const {selectedCabinetGroup} = useRoomPlannerContext();
    const {handleClick} = useMenuContext();
    const dispatch = useAppDispatch();
    const openPlaceholderEditor = useOpenPlaceholderEditor();

    const handleEditClick = useCallback(() => {
        if (selectedCabinetGroup?.userData?.isPlaceholder) {
            openPlaceholderEditor();
            return;
        }

        if (selectedCabinetGroup) {
            const userData = selectedCabinetGroup.userData;

            const cabinetId =
                userData?.values?.job_cabinet_id?.toString() ?? '';
            const productType = userData?.values?.type?.toString() ?? '';

            searchParams.set('cabinetId', cabinetId);
            searchParams.set('product', productType);
            searchParams.set('preventReset', 'true');
            searchParams.delete('placeholderEdit');
            searchParams.delete('placeholderFace');
            searchParams.delete('placeholderName');
            searchParams.delete('category');
            searchParams.delete('subCategory');
            setSearchParams(searchParams);

            dispatch(setIsRoomPlannerEditing(true));
            dispatch(setBackupProductValues(userData?.values));

            if (typeof handleClick === 'function') {
                handleClick(MenuItem.ADD_PRODUCT);
            }
        }
    }, [
        selectedCabinetGroup,
        searchParams,
        setSearchParams,
        dispatch,
        handleClick,
        openPlaceholderEditor,
    ]);

    return {handleEditClick};
};
